import React, { useEffect, useRef, useState } from 'react'
import { Search, X, Check } from 'lucide-react'
import { translations } from '../../utils/constants'
import { useDispatch, useSelector } from 'react-redux'
import { setDeviceTypeFilter } from '../../Redux/actions/deviceType'
import { setDeviceTypeCount } from '../../Redux/actions/deviceAction'
const SearchDeviceType = ({ selectedTypes = [], handleDeviceTypeChange, setSearchDeviceTypeModal, searchDeviceTypeModal, language, availableDeviceTypes = [], deviceTypeCounts = [] }) => {
    const [searchQuery, setSearchQuery] = useState('')
    const dispatch = useDispatch()
    const reduxSelected = useSelector(state => state.deviceTypeReducer?.deviceTypeFilter)
    const [selected, setSelected] = useState(reduxSelected || [])
    const modalRef = useRef(null)

    useEffect(() => {
        dispatch(setDeviceTypeCount(reduxSelected?.length || 0))
    }, [reduxSelected, dispatch])

    useEffect(() => {
        if (!searchDeviceTypeModal) {
            setSearchQuery('')
        }
    }, [searchDeviceTypeModal])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setSearchDeviceTypeModal(false)
            }
        }

        if (searchDeviceTypeModal) {
            document.addEventListener('mousedown', handleClickOutside)
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [searchDeviceTypeModal, setSearchDeviceTypeModal])

    const filteredTypes = availableDeviceTypes?.filter(type =>
        type.label?.toLowerCase()?.includes(searchQuery.toLowerCase())
    )

    const closeModal = () => setSearchDeviceTypeModal(false)

    const toggleType = (type) => {
        const updated = selected.includes(type)
            ? selected?.filter(t => t !== type)
            : [...selected, type]

        setSelected(updated)
        dispatch(setDeviceTypeFilter(updated))
        // handleDeviceTypeChange(updated)
    }

    const handleSelectAll = () => {
        if (selected?.length > 1) {
            setSelected([])
            dispatch(setDeviceTypeFilter([]))
        }
        else {
            const allTypes = availableDeviceTypes.map(type => type.value)
            setSelected(allTypes)
            dispatch(setDeviceTypeFilter(allTypes))
        }
    }

    const onSearchChange = (event) => {
        setSearchQuery(event.target.value)
    }

    return (
        <div className="search-organization-container" ref={modalRef}>
            <span className="close-icon-search" onClick={closeModal}><X /></span>
            <div className="search-organization-header">
                <h1>{translations[language]?.typeOfDevice}</h1>
            </div>

            <div className="search-inner-div search-input-div2" style={{ margin: '0px' }}>
                <Search className="search-icon" />
                <input
                    type="text"
                    placeholder={translations[language]?.searchdevicetype}
                    value={searchQuery}
                    onChange={onSearchChange}
                    className="search-input"
                />
            </div>

            <div className="organizations-header">
                <div className="organization-search-text">{translations[language]?.typeOfDevice}</div>
                <div onClick={handleSelectAll} className="select-all-button">
                    {selected.length > 1
                        ? translations[language]?.clearAll
                        : translations[language]?.selectAll}
                </div>
            </div>

            <div className="organizations-list-div">
                <div className="organizations-list">
                    {filteredTypes?.map((type) => {
                        const count = deviceTypeCounts?.find(d => d.device_type === type.value)?.count || 0

                        return (
                            <div
                                key={type.value}
                                onClick={() => toggleType(type.value)}
                                className={`organization-item ${selected.includes(type.value) ? 'selected' : ''}`}
                            >
                                <div className="checkbox">
                                    {selected.includes(type.value) && <Check className="check-icon" />}
                                </div>

                                <div>
                                    <div className="organization-name capitalized-name">{type.label}</div>
                                    <div className="organization-users">{count} {translations[language]?.devices}</div>
                                </div>

                            </div>
                        )
                    })}
                </div>

                {filteredTypes?.length === 0 && (
                    <div className="no-results">
                        {translations[language]?.noDeviceTypesFound}
                    </div>
                )}
            </div>
        </div>
    )
}

export default SearchDeviceType
